import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { EndasureService } from 'src/app/services/feature/Endasure/endasure.service';
import { SmartTireService } from 'src/app/services/feature/smartTire/smart-tire.service';

@Component({
    selector: 'app-smarttire-maintaince-info',
    templateUrl: './smarttire-maintaince-info.component.html',
    styleUrl: './smarttire-maintaince-info.component.scss',
    standalone: false
})
export class SmarttireMaintainceInfoComponent {

 private destroy$ = new Subject<void>();
  constructor(private SmartTireService :SmartTireService,private cdr:ChangeDetectorRef,
    public endasureService:EndasureService){}

  ngOnInit() {
    this.SmartTireService.maintenance$.pipe(takeUntil(this.destroy$))
    .subscribe(data=>{
      if(data!=null){
        this.MaintainceInfoForm.patchValue({
          costOfDiesel: data.costOfDiesel || 2.70,
          costPerTire: data.costPerTire || 350.00,
          serviceCostUSD: data.serviceCostUSD || 4.00,
          serviceCostMins: data.serviceCostMins || 2,
          serviceCostHours: data.serviceCostHours || 15.00,
          costPerDowntime: data.costPerDowntime || 500.00,         
        });
      }
   
    })
    
  }

  MaintainceInfoForm = new FormGroup({
    costOfDiesel: new FormControl(2.70,{ validators: Validators.required }),
    costPerTire: new FormControl(350.00, { validators: Validators.required }),
    serviceCostUSD: new FormControl(4.00, { validators: Validators.required }),
    serviceCostMins: new FormControl(2, { validators: Validators.required }),   
    serviceCostHours: new FormControl(15.00, { validators: Validators.required }),
    costPerDowntime: new FormControl(500.00, { validators: Validators.required }),  
   
  });

 
  get form() {
    return this.MaintainceInfoForm.controls;
  }
  endaSureNxt(){    
    if(this.MaintainceInfoForm.valid){
      this.SmartTireService.maintenance$.next(this.MaintainceInfoForm.value);
     this.SmartTireService.currentComponent$.next('savings'); 
    
    }
    else{
      this.MaintainceInfoForm.markAllAsTouched();
    }  
    this.cdr.detectChanges();   
  }
  endaSureBack(){
    if(this.MaintainceInfoForm.valid){
      this.SmartTireService.currentComponent$.next('fleetInfo'); 
    }
    else{
      this.MaintainceInfoForm.markAllAsTouched();
    }   
    this.cdr.detectChanges();    
  }


  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}

